import React, { useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import PlusIcon from './assets/images/plus-icon.svg';
import Efticon from './assets/images/eftekle_icon.svg';
import NotEkleIcon from './assets/images/notekle_icon.svg';
import DownloadIcon from './assets/images/download_icon.svg';
import EditIcon from './assets/images/edit-icon.svg';
import DeleteIcon from './assets/images/delete-icon.svg';
import TransferIcon from './assets/images/transfericon.svg';
import NotEkleModal from './NotEkleModal';

function OdemeEkleModal({ isOpen, onClose, onSave, siparis, odeme }) {
    const [odemeMiktari, setOdemeMiktari] = useState('');
    const [odemeTarihi, setOdemeTarihi] = useState(new Date().toISOString().split('T')[0]);
    const [odemeYapanTuru, setOdemeYapanTuru] = useState('kendisi');
    const [odemeYapanAdi, setOdemeYapanAdi] = useState('');

    useEffect(() => {
        if (isOpen) {
            setOdemeMiktari(odeme ? String(odeme.miktar) : '');
            setOdemeTarihi(odeme?.odeme_tarihi_iso || new Date().toISOString().split('T')[0]);
            setOdemeYapanTuru(odeme?.odeme_yapan === 'Kendisi' || !odeme ? 'kendisi' : 'diger');
            setOdemeYapanAdi(odeme?.odeme_yapan === 'Kendisi' ? '' : (odeme?.odeme_yapan || ''));
        }
    }, [isOpen, odeme]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        const odemeTutari = Number(odemeMiktari);
        const kalanBedel = Number(siparis.kalan_bedel || 0) + (odeme ? Number(odeme.miktar || 0) : 0);

        if (!Number.isFinite(odemeTutari) || odemeTutari <= 0) {
            alert('Ödeme tutarı sıfırdan büyük olmalıdır.');
            return;
        }

        if (odemeTutari > kalanBedel + 0.000001) {
            alert(`Ödeme toplam bedeli aşamaz. En fazla ${Math.max(0, kalanBedel).toFixed(2)} ₺ ödeme girebilirsiniz.`);
            return;
        }

        onSave(siparis.id, {
            odeme_miktari: odemeTutari,
            odeme_tarihi: odemeTarihi,
            odeme_yapan_turu: odemeYapanTuru,
            odeme_yapan_adi: odemeYapanAdi
        }, odeme?.id);
    };
    const odemeUstSiniri = Math.max(0, Number(siparis.kalan_bedel || 0) + (odeme ? Number(odeme.miktar || 0) : 0));
    
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
            <div style={{background: '#F8F8F8', padding: '25px', borderRadius: '8px',  width: '400px',  }} onClick={e => e.stopPropagation()}>
                <p><strong>Müşteri:</strong> {siparis.ad_soyad}</p>
                <p><strong>Kalan Bedel:</strong> {Number(siparis.kalan_bedel || 0).toFixed(2)} ₺</p>
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '15px' }}>
                        <label>Ödeme Tarihi:</label>
                        <input type="date" value={odemeTarihi} onChange={e => setOdemeTarihi(e.target.value)} required style={{ width: '100%', padding: '8px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label>Ödeme Miktarı (₺):</label>
                        <input type="number" step="0.01" min="0.01" max={odemeUstSiniri.toFixed(2)} value={odemeMiktari} onChange={e => setOdemeMiktari(e.target.value)} required style={{ width: '100%', padding: '8px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label>Ödeme Yapan:</label>
                        <select value={odemeYapanTuru} onChange={e => setOdemeYapanTuru(e.target.value)} style={{ width: '100%', padding: '8px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}>
                            <option value="kendisi">Kendisi</option>
                            <option value="diger">Diğer</option>
                        </select>
                    </div>
                    {odemeYapanTuru === 'diger' && (
                        <div style={{ marginBottom: '15px' }}>
                            <label>Ödeme Yapan Kişi:</label>
                            <input type="text" value={odemeYapanAdi} onChange={e => setOdemeYapanAdi(e.target.value)} required placeholder="İsim Soyisim" style={{ width: '100%', padding: '8px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} />
                        </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button type="button" onClick={onClose} style={{
                            width: '110px',
                            height: '37px',
                            background: '#F8F8F8',
                            borderRadius: '8px',
                            border: '0.50px black solid',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>Vazgeç</button>
                        <button type="submit" style={{
                            width: '110px',
                            height: '37px',
                            background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                            borderRadius: '8px',
                            border: '0.50px black solid',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500' 
                         }}>{odeme ? 'Ödemeyi Güncelle' : 'Ödeme Kaydet'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

function EftTakibi() {
    // --- STATE'LER ---
    const [siparisler, setSiparisler] = useState([]);
    const [loading, setLoading] = useState(true);
    const [seciliAy, setSeciliAy] = useState(new Date().toISOString().slice(0, 7));
    const [seciliDurum, setSeciliDurum] = useState('All'); 
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentSiparis, setCurrentSiparis] = useState(null);
    const [isNotModalOpen, setIsNotModalOpen] = useState(false);
    const [aramaTerimi, setAramaTerimi] = useState('');
    const [eftListeTarihModalAcik, setEftListeTarihModalAcik] = useState(false);
    const [eftListeTarih, setEftListeTarih] = useState(new Date().toISOString().split('T')[0]);
    const [acikSiparisId, setAcikSiparisId] = useState(null);
    const [duzenlenenOdeme, setDuzenlenenOdeme] = useState(null);

    // --- FONKSİYONLAR ---

    // Backend'den EFT/Havale ve Kurum Ödemesi siparişlerini çeken ana fonksiyon
    const fetchEftSiparisleri = () => {
        setLoading(true);
        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            window.location.href = '/login';
            return;
        }

        // URL artık hem 'ay' hem de 'status' parametrelerini kullanıyor
        const url = `/api/siparisler/eft-takip?ay=${seciliAy}&status=${seciliDurum}`;
        fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(res => {
            if (res.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }
            return res.ok ? res.json() : Promise.reject('Veri çekilemedi');
        })
        .then(data => { 
            setSiparisler(data); 
            setLoading(false); 
        })
        .catch(error => { 
            console.error('Hata:', error); 
            setSiparisler([]); 
            setLoading(false); 
        });
    };

    // Seçili ay veya durum değiştiğinde siparişleri yeniden çeker
    useEffect(() => {
        if (seciliAy) {
            fetchEftSiparisleri();
        }
    }, [seciliAy, seciliDurum]); // seciliDurum'un burada olması çok önemli
    
    // Ödeme durumu için stil döndüren yardımcı fonksiyon
    const getStatusStyle = (status) => {
        switch (status) {
            case 'Tamamı Ödendi':
                return { background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb' };
            case 'Kısmen Ödendi':
                return { background: '#fff3cd', color: '#856404', border: '1px solid #ffeeba' };
            case 'Ödenmedi':
                return { background: '#f8d7da', color: '#721c24', border: '1px solid #f5c6cb' };
            default:
                return { background: '#e2e3e5', color: '#383d41', border: '1px solid #d6d8db' };
        }
    };
    
    // Ödeme yöntemleri için renkler ve tam isimler
    const odemeRenkleri = { E: '#6761a8', D: '#bb999c', B: '#a32e68', O: '#2c6184' }; // E: EFT/Havale, D: Diğer (Kurum Ödemesi), B: Ücretsiz Gönderi, O: Online (W-O, takip sayfasından)
    const odemeYontemleri = { E: 'EFT/Havale', D: 'Kurum Ödemesi', B: 'Ücretsiz Gönderi', O: 'Online Ödeme' };

    const handleOdemeEkleClick = (siparis) => {
        setCurrentSiparis(siparis);
        setDuzenlenenOdeme(null);
        setIsModalOpen(true);
    };

    const handleOdemeDuzenleClick = (siparis, odeme) => {
        setCurrentSiparis(siparis);
        setDuzenlenenOdeme(odeme);
        setIsModalOpen(true);
    };

    const filtrelenmisSiparisler = siparisler.filter(siparis => {
        const arama = aramaTerimi.toLowerCase();
        // Backend'den gelen 'telefon' ve 'ad_soyad' alanlarına göre filtreleme
        return (siparis.ad_soyad || '').toLowerCase().includes(arama) || 
               (siparis.telefon || '').includes(arama);
    });

    // YENİ: Ödemeyi kaydeden fonksiyon
    const handleSaveOdeme = (siparisId, odemeData, odemeId) => {
        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            return;
        }

        fetch(odemeId
            ? `/api/siparisler/${siparisId}/odemeler/${odemeId}`
            : `/api/siparisler/${siparisId}/odeme`, {
            method: odemeId ? 'PUT' : 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(odemeData)
        })
        .then(res => {
            if (res.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }
            return res.json();
        })
        .then(data => {
            if (data.hata) throw new Error(data.hata);
            alert(data.mesaj);
            setIsModalOpen(false);
            setDuzenlenenOdeme(null);
            fetchEftSiparisleri(); // Listeyi yenile
        })
        .catch(error => alert(`Hata: ${error.message}`));
    };

    const handleOdemeSil = async (siparisId, odemeId) => {
        if (!window.confirm('Bu ödeme kaydı silinecek. Emin misiniz?')) return;

        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            return;
        }

        try {
            const response = await fetch(`/api/siparisler/${siparisId}/odemeler/${odemeId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            if (!response.ok || data.hata) throw new Error(data.hata || 'Ödeme silinemedi.');
            alert(data.mesaj);
            fetchEftSiparisleri();
        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    // "Not Ekle" ikonuna tıklandığında çalışır
    const handleNotEkleClick = (siparis) => {
        setCurrentSiparis(siparis); // Hangi sipariş için not ekleneceğini ayarla
        setIsNotModalOpen(true);    // Not modalını aç
    };

    // EFT Günlük Liste PDF oluşturma
    const handleEftListesiIndir = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`/api/siparisler/eft-liste-gunluk?tarih=${eftListeTarih}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (!res.ok) {
                alert(data.hata || 'Veri alınamadı.');
                return;
            }
            const { tarih, siparisler: liste } = data;
            if (!liste || liste.length === 0) {
                alert('Seçilen tarihte EFT/Havale siparişi bulunamadı.');
                return;
            }

            const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a5', compress: true });
            pdf.setFont('helvetica', 'normal');

            const pageWidth = pdf.internal.pageSize.getWidth();   // 148mm
            const pageHeight = pdf.internal.pageSize.getHeight();  // 210mm

            // Başlık
            const [yil, ay, gun] = tarih.split('-');
            const gunler = ['Pazar', 'Pazartesi', 'Sali', 'Carsamba', 'Persembe', 'Cuma', 'Cumartesi'];
            const gunAdi = gunler[new Date(tarih).getDay()];
            pdf.setFontSize(12);
            pdf.setFont('helvetica', 'bold');
            pdf.text(`${gun}/${ay}/${yil} ${gunAdi} - EFT/Havale Listesi`, pageWidth / 2, 13, { align: 'center' });

            // Kolon tanımları (A5: 148mm, kenar boşluğu ~5mm her yanda)
            //    | Telefon | Ad Soyad      | Tutar | Ödeme Yapan
            const kolonlar = [
                { baslik: '',             x: 5,   genislik: 8,  solYasli: false },
                { baslik: 'Telefon',      x: 13,  genislik: 24, solYasli: false },
                { baslik: 'Ad Soyad',     x: 37,  genislik: 38, solYasli: true  },
                { baslik: 'Tutar',        x: 75,  genislik: 20, solYasli: false },
                { baslik: 'Odeme Yapan',  x: 95,  genislik: 48, solYasli: false },
            ];

            // Türkçe karakterleri ASCII karşılıklarıyla değiştirir (jsPDF helvetica desteği için)
            const normalizeTr = (str) => (str || '')
                .replace(/ş/g,'s').replace(/Ş/g,'S')
                .replace(/ı/g,'i').replace(/İ/g,'I')
                .replace(/ğ/g,'g').replace(/Ğ/g,'G')
                .replace(/ü/g,'u').replace(/Ü/g,'U')
                .replace(/ö/g,'o').replace(/Ö/g,'O')
                .replace(/ç/g,'c').replace(/Ç/g,'C');

            const satirH = 7;
            let yPos = 22;

            pdf.setFontSize(8);
            // Başlık satırı
            pdf.setFont('helvetica', 'bold');
            kolonlar.forEach(k => {
                pdf.rect(k.x, yPos - 5, k.genislik, satirH);
                const tw = pdf.getStringUnitWidth(k.baslik) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
                pdf.text(k.baslik, k.x + (k.genislik / 2) - (tw / 2), yPos);
            });
            yPos += satirH;

            pdf.setFont('helvetica', 'normal');

            [...liste].reverse().forEach((s, idx) => {
                if (yPos > pageHeight - 15) {
                    pdf.addPage();
                    yPos = 15;
                }

                const telMetin = s.alternatif_son4
                    ? `${s.telefon_son4} (${s.alternatif_son4})`
                    : s.telefon_son4;

                const tutarMetin = `${(s.toplam_bedel || 0).toFixed(2)}`;

                // Ad Soyad - Türkçe karakter normalize + kırpılabilir
                const adMaks = 22;
                const adHam = normalizeTr(s.ad_soyad);
                const adMetin = adHam.length > adMaks ? adHam.substring(0, adMaks) + '.' : adHam;
                const odemeYapan = normalizeTr(s.odeme_yapan || '');

                const veriler = [
                    (idx + 1).toString(),
                    telMetin,
                    adMetin,
                    tutarMetin,
                    odemeYapan
                ];

                const odemeYapanSatirlari = pdf.splitTextToSize(odemeYapan, kolonlar[4].genislik - 4);
                const satirYuksekligi = Math.max(satirH, odemeYapanSatirlari.length * 4 + 3);

                if (yPos + satirYuksekligi > pageHeight - 15) {
                    pdf.addPage();
                    yPos = 15;
                }

                kolonlar.forEach((k, i) => {
                    pdf.rect(k.x, yPos - 5, k.genislik, satirYuksekligi);
                    const metin = veriler[i] || '';
                    if (k.solYasli) {
                        pdf.text(metin, k.x + 2, yPos);
                    } else if (i === 4) {
                        pdf.text(odemeYapanSatirlari, k.x + 2, yPos);
                    } else {
                        const tw = pdf.getStringUnitWidth(metin) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
                        pdf.text(metin, k.x + (k.genislik / 2) - (tw / 2), yPos);
                    }
                });

                yPos += satirYuksekligi;
            });

            pdf.save(`${tarih}_eft_listesi.pdf`);
            setEftListeTarihModalAcik(false);
        } catch (err) {
            console.error('EFT Listesi PDF hatası:', err);
            alert('PDF oluşturulurken bir hata oluştu.');
        }
    };

    // Not modalındaki "Kaydet" butonuna basıldığında çalışır
    const handleSaveNot = (siparisId, not) => {
        const token = localStorage.getItem('token');
        if (!token) {
            alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
            return;
        }

        fetch(`/api/siparisler/${siparisId}/not`, {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ notlar: not })
        })
        .then(res => {
            if (res.status === 401) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }
            return res.json();
        })
        .then(data => {
            if (data.hata) throw new Error(data.hata);
            alert(data.mesaj);
            setIsNotModalOpen(false);
            // --- BU SATIRI EKLEYİN ---
            fetchEftSiparisleri(); // Not kaydedildikten sonra listeyi yenile
            // -------------------------
        })
        .catch(error => {
            console.error('Not kaydedilirken hata:', error);
            alert(`Hata: ${error.message}`);
        });
    };

    return (
        <div style={{ background: '#F8F8F8', padding: '20px', borderRadius: '8px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
            <style>{`
                .siparis-satiri {
                    transition: all 0.2s ease-in-out;
                }
                .siparis-satiri:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                    z-index: 10;
                    position: relative;
                }
                `}</style>
             <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '25px', // Tüm elemanlar arasında eşit boşluk
                marginBottom: '20px', 
                padding: '15px', 
                background: '#F8F8F8', 
                borderRadius: '8px', 
                fontFamily: 'poppins', 
                flexShrink: 0
            }}>
                
                {/* Ay Filtresi */}
                <div>
                    <label style={{ fontWeight: '500', marginRight: '10px' }}>Ay Seçiniz:</label>
                    <input 
                        type="month" 
                        value={seciliAy}
                        onChange={(e) => setSeciliAy(e.target.value)}
                        style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins', }} 
                    />
                </div>

                {/* Ödenme Durumu Filtresi */}
                <div>
                    <label style={{ fontWeight: '500', marginRight: '10px' }}>Ödenme Durumu:</label>
                    <select
                        value={seciliDurum}
                        onChange={(e) => setSeciliDurum(e.target.value)}
                        style={{ padding: '6px', border: '1px solid #ccc', borderRadius: '4px', minWidth: '180px', fontFamily: 'poppins', }}
                    >
                        <option value="All">Tümü</option>
                        <option value="Ödenmedi">Ödenmedi</option>
                        <option value="Kısmen Ödendi">Kısmen Ödendi</option>
                        <option value="Tamamı Ödendi">Tamamı Ödendi</option>
                    </select>
                </div>

                {/* Arama Kutusu */}
                <div>
                    <input 
                        type="text" 
                        placeholder="Müşteri veya Tel No Ara..."
                        value={aramaTerimi}
                        onChange={(e) => setAramaTerimi(e.target.value)}
                        style={{ padding: '6.5px', border: '1px solid #ccc', borderRadius: '4px', width: '300px', fontFamily: 'poppins', }}
                    />
                </div>

                {/* EFT Listesi İndir Butonu */}
                <div style={{ marginLeft: 'auto' }}>
                    <button
                        onClick={() => setEftListeTarihModalAcik(true)}
                        style={{ padding: '6px 12px', background: '#F8F8F8', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '7px' }}
                    >
                        <img src={DownloadIcon} alt="İndir" style={{ height: '14px' }} />
                        <span>EFT Listesi İndir</span>
                    </button>
                </div>
            </div>

            {/* Tarih Seçim Modalı */}
            {eftListeTarihModalAcik && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.45)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 }}
                    onClick={() => setEftListeTarihModalAcik(false)}>
                    <div style={{ background: '#F8F8F8', padding: '28px', borderRadius: '8px', width: '320px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}
                        onClick={e => e.stopPropagation()}>
                        <h3 style={{ margin: '0 0 18px 0', fontFamily: 'poppins', fontWeight: '600', fontSize: '15px' }}>EFT Listesi - Gün Seçin</h3>
                        <label style={{ fontFamily: 'poppins', fontWeight: '500', display: 'block', marginBottom: '8px' }}>Tarih:</label>
                        <input
                            type="date"
                            value={eftListeTarih}
                            onChange={e => setEftListeTarih(e.target.value)}
                            style={{ width: '100%', padding: '7px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'poppins', boxSizing: 'border-box', marginBottom: '20px' }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button onClick={() => setEftListeTarihModalAcik(false)} style={{ padding: '7px 18px', background: '#F8F8F8', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontFamily: 'poppins' }}>Vazgeç</button>
                            <button onClick={handleEftListesiIndir} style={{ padding: '7px 18px', background: '#F8F8F8', border: '1px solid #333', borderRadius: '6px', cursor: 'pointer', fontFamily: 'poppins', fontWeight: '600' }}>İndir</button>
                        </div>
                    </div>
                </div>
            )}
            {loading ? (
                <div>Yükleniyor...</div>
            ) : (
                <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '13px' }}>
                    <thead>
                        <tr style={{ background: '#E5E5E5', height: '35px' }}>
                            <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Sipariş Tarihi</th>
                            <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Telefon</th>
                            <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Ad Soyad</th>
                            <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', width: '170px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Toplam Bedel</th>
                            <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', width: '140px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Ödeme Yöntemi</th>
                            <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', width: '140px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Ödenme Durumu</th>
                            <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Ödeme Tarihi</th>
                            <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Ödenen Bedel</th>
                            <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Kalan Bedel</th>
                            <th style={{ padding: '12px', textAlign: 'center', fontWeight: '600', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Artık filtrelenmiş liste üzerinden map yapılıyor */}
                        {filtrelenmisSiparisler.length > 0 ? (
                            filtrelenmisSiparisler.map((siparis) => (
                                <React.Fragment key={siparis.id}>
                                <tr
                                    className="siparis-satiri"
                                    onClick={() => setAcikSiparisId(acikSiparisId === siparis.id ? null : siparis.id)}
                                    style={{ background: '#ffffff', height: '24px', borderBottom: '1px solid #eee', cursor: 'pointer' }}
                                >
                                    <td style={{ padding: '12px' }}>{siparis.siparis_tarihi}</td>
                                    <td style={{ padding: '12px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <span>{siparis.telefon}</span>
                                            {siparis.alternatif_telefon && (
                                                <img
                                                    src={TransferIcon}
                                                    title={`Diğer numara: ${siparis.alternatif_telefon}`}
                                                    alt="Alternatif numara"
                                                    style={{ height: '13px', width: '13px', flexShrink: 0 }}
                                                />
                                            )}
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px' }}>{siparis.ad_soyad}</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>{(siparis.toplam_bedel || 0).toFixed(2)} ₺</td>
                                    <td style={{ padding: '12px' }}>
                                        <div style={{
                                            background: odemeRenkleri[siparis.odeme_yontemi],
                                            color: 'white',
                                            padding: '3px 8px',
                                            borderRadius: '4px',
                                            display: 'inline-block',
                                            fontSize: '12px',
                                            fontWeight: 'regular',
                                            textAlign: 'center',
                                            minWidth: '140px'
                                        }}>
                                            {odemeYontemleri[siparis.odeme_yontemi] || siparis.odeme_yontemi}
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center', fontSize: '12px',  }}>
                                        <span style={{ padding: '3px 8px', borderRadius: '4px', ...getStatusStyle(siparis.odeme_durumu) }}>
                                            {siparis.odeme_durumu}
                                        </span>
                                    </td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>{siparis.odeme_tarihi || '-'}</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>{(siparis.odenen_bedel || 0).toFixed(2)} ₺</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>{(siparis.kalan_bedel || 0).toFixed(2)} ₺</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                        <button 
                                            onClick={(e) => { e.stopPropagation(); handleOdemeEkleClick(siparis); }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: '5px' // İkonun etrafında tıklama alanı için
                                            }}
                                        >
                                            <img src={Efticon} alt="Ödeme Ekle" style={{ height: '20px', width: '20px' }} />
                                        </button>
                                        <button 
                                            onClick={(e) => { e.stopPropagation(); handleNotEkleClick(siparis); }} title="Not Ekle/Düzenle" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '5px' }}>
                                            <img src={NotEkleIcon} alt="Not Ekle" style={{ height: '20px', width: '20px' }} />
                                        </button>    
                                    </td>
                                </tr>
                                {acikSiparisId === siparis.id && (
                                    <tr>
                                        <td colSpan="10" style={{ padding: '10px', background: '#f2f4f7' }}>
                                            <div style={{ border: '1px solid #e1e5ea', borderRadius: '6px', padding: '10px 12px', background: '#fff', fontFamily: 'Poppins' }}>
                                                <strong style={{ display: 'block', marginBottom: '8px' }}>Ödeme Geçmişi</strong>
                                                {siparis.odemeler?.length ? (
                                                    siparis.odemeler.map((odeme) => (
                                                        <div key={odeme.id} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '7px 0', borderBottom: '1px solid #f0f0f0', fontSize: '12px' }}>
                                                            <span style={{ minWidth: '120px' }}>{odeme.odeme_tarihi}</span>
                                                            <span style={{ minWidth: '100px', fontWeight: '600' }}>{Number(odeme.miktar || 0).toFixed(2)} ₺</span>
                                                            <span style={{ flex: 1 }}>
                                                                {odeme.odeme_yapan}
                                                                {odeme.online && (
                                                                    <span title="Müşteri takip sayfasından kartla (iyzico) ödedi"
                                                                        style={{ marginLeft: '8px', padding: '1px 6px', borderRadius: '3px', fontSize: '10px', background: '#2c6184', color: '#fff' }}>
                                                                        Online
                                                                    </span>
                                                                )}
                                                            </span>
                                                            <button
                                                                onClick={(e) => { e.stopPropagation(); handleOdemeDuzenleClick(siparis, odeme); }}
                                                                title="Düzenle"
                                                                style={{ border: 'none', background: 'none', padding: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                                            ><img src={EditIcon} alt="Düzenle" style={{ width: '15px', height: '15px' }} /></button>
                                                            <button
                                                                onClick={(e) => { e.stopPropagation(); handleOdemeSil(siparis.id, odeme.id); }}
                                                                title="Sil"
                                                                style={{ border: 'none', background: 'none', padding: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                                            ><img src={DeleteIcon} alt="Sil" style={{ width: '15px', height: '15px' }} /></button>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <span style={{ color: '#777', fontSize: '12px' }}>Bu sipariş için kayıtlı ödeme geçmişi bulunmuyor.</span>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>Veri bulunamadı veya arama kriterlerine uyan sonuç yok.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                </div>
            )}
            <OdemeEkleModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSave={handleSaveOdeme}
                siparis={currentSiparis}
                odeme={duzenlenenOdeme}
            />
            <NotEkleModal
                isOpen={isNotModalOpen}
                onClose={() => setIsNotModalOpen(false)}
                onSave={handleSaveNot}
                siparis={currentSiparis}
            />
        </div>
    );
}

export default EftTakibi;